import { SEARCH_SERVICE_PROVIDERS, ADOBE_GRS_TARGET_SEGMENT_LOCAL_STORAGE_KEY, SEARCH_PROVIDER_SESSION_STORAGE_KEY } from "../../constants/grs.js";
import { getSearchProvider } from "../../utils/grs.js";
import { useLocalStorage } from "../useLocalStorage/index.js";
import { useSessionStorage } from "../useSessionStorage/index.js";
const getSafeSearchProvider = (searchProviderStorage) => {
  return typeof searchProviderStorage === "string" ? searchProviderStorage : null;
};
const useSearchProvider = ({
  isGRSFeatureFlagEnabled,
  isGRSBetaReleaseFeatureFlagEnabled
}) => {
  const [searchProviderSessionStorage, _setSearchProviderSessionStorage] = useSessionStorage(
    SEARCH_PROVIDER_SESSION_STORAGE_KEY,
    SEARCH_SERVICE_PROVIDERS.LUCIDWORKS
  );
  const [searchProviderLocalStorage, _setSearchProviderLocalStorage] = useLocalStorage(
    ADOBE_GRS_TARGET_SEGMENT_LOCAL_STORAGE_KEY,
    SEARCH_SERVICE_PROVIDERS.LUCIDWORKS
  );
  const searchProvider = getSearchProvider(
    isGRSFeatureFlagEnabled,
    isGRSBetaReleaseFeatureFlagEnabled,
    getSafeSearchProvider(searchProviderSessionStorage),
    getSafeSearchProvider(searchProviderLocalStorage)
  );
  return searchProvider;
};
export {
  useSearchProvider
};
